(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mastersdice-bundle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mastersdice-bundle')) {
  class MastersdiceBundle extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      try {
        this.config = JSON.parse(this.querySelector('[data-config]').textContent);
        this.variants = this.config.variants;
        const available = this.variants.filter(v => v.available);
        const first = available.find(v => v.id === this.config.initial) || available[0] || this.variants[0];
        if (!first) return;
        const defaults = [first, ...available.filter(v => v.id !== first.id)];
        this.picks = Array.from({length:10}, (_,i) => (defaults[i % defaults.length] || first).id);
        this.count = 1;
        this.openIndex = null;
        this.busy = false;
        this.pending = null;
        this.listeners = [];
        this.listen(this,'click', e => this.click(e));
        this.listen(this,'change', e => {
          if (e.target.matches('[data-tier]') && !this.busy) {
            this.count = Number(e.target.value);
            this.openIndex = null;
            this.clearError();
            const offers = this.querySelector('[data-offers]');
            const before = offers.getBoundingClientRect().top;
            this.render();
            const shift = offers.getBoundingClientRect().top - before;
            if (Math.abs(shift) > 1) window.scrollBy(0, shift);
            this.querySelector(`[data-tier][value="${this.count}"]`).focus({preventScroll:true});
          }
        });
        this.listen(this,'keydown', e => {
          if (e.key === 'Escape' && this.openIndex !== null) { e.preventDefault(); this.closePicker(); }
        });
        this.listen(document,'click', e => {
          if (!e.composedPath().includes(this) && this.openIndex !== null) this.closePicker(false);
        });
        this.listen(window,'click', e => {
          const close = e.target.closest('cart-drawer .drawer__close');
          const drawer = close?.closest('cart-drawer');
          if (this.ready && drawer?.hasAttribute('open') && typeof drawer.hide === 'function') {
            e.preventDefault();
            e.stopImmediatePropagation();
            drawer.hide();
          }
        }, true);
        this.info = this.closest('product-info');
        this.form = document.getElementById(this.info?.getAttribute('form'));
        if (!this.form) { this.removeListeners(); return; }
        this.listen(this.form,'variant:change', e => {
          const variant = this.variants.find(v => v.id === e.detail?.variant?.id);
          if (variant) {
            if (this.busy) this.queuedNativeVariant = variant.id;
            else {
              const focusedTrigger = document.activeElement?.closest('.mdb-trigger');
              const focusedIndex = focusedTrigger && this.contains(focusedTrigger) ? focusedTrigger.dataset.open : null;
              this.picks[0] = variant.id;
              this.render();
              if (focusedIndex !== null) this.querySelector(`.mdb-trigger[data-open="${focusedIndex}"]`)?.focus({preventScroll:true});
            }
          }
        });
        this.listen(this.form,'submit', e => { if (this.count === 1) return; e.preventDefault(); e.stopImmediatePropagation(); this.add(); }, true);
        this.setupLive();
        this.setupSticky();
        this.render();
        this.hidden = false;
        this.ready = true;
        this.updateSticky();
      } catch (error) { this.removeListeners(); this.hidden = true; }
    }
    disconnectedCallback() {
      this.removeListeners();
      this.checkoutNote?.remove();
      this.sticky?.remove();
      this.closeGift();
      this.sticky = null;
      document.body.classList.remove('mdb-has-sticky');
      this.form?.closest('.product-form-wrapper')?.classList.remove('mdb-native-hidden', 'mdb-native-single');
      this.ready = false;
    }
    escape(value) { return String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }
    text(key) { return this.config.text[key]; }
    money(value) { return new Intl.NumberFormat(this.config.locale, {style:'currency',currency:this.config.currency}).format(value / 100); }
    selected(count = this.count) { return this.picks.slice(0,count).map(id => this.variants.find(v => v.id === id)); }
    totals(count = this.count) {
      const selected = this.selected(count);
      const subtotal = selected.reduce((sum,v) => sum + v.price, 0);
      return {subtotal, total:subtotal, compare:selected.reduce((sum,v) => sum + Math.max(v.price,v.compare_at_price || 0),0)};
    }
    image(v, size = 52, preview = false) {
      // The cards show these at 48–80px, so the 240px file is enough; the 800px preview made every style switch slow on phones.
      const url = v.image || v.preview;
      return url ? `<img src="${this.escape(url)}" alt="${preview ? this.escape(v.title) : ''}" width="${size}" height="${size}" decoding="async">` : '';
    }
    render() {
      const esc = v => this.escape(v);
      const gifts = this.config.gifts;
      const picksHome = this.querySelector('[data-shipping]');
      const picksEl = this.querySelector('[data-picks]');
      if (picksEl && picksHome && picksEl.nextElementSibling !== picksHome) picksHome.before(picksEl);
      this.querySelector('[data-offers]').innerHTML = this.tierCounts().map(count => {
        const amount = this.totals(count);
        const gift = this.config.eligible && count >= 3 ? gifts[count] : '';
        const shipping = this.config.country === 'US' && this.config.currency === 'USD' && amount.total >= 5000;
        const title = count === 1 ? this.text('one') : count === 2 ? this.text('two') : gifts.items.replace('{count}',count);
        const badge = ''; // Badges dropped: the gift photos in the row say it.
        const benefit = gift ? '' : count === 2 ? this.text('pair_reason') + (shipping ? ' · Free U.S. shipping' : '') : '';
        const active = count === this.count;
        return `<div class="mdb-offer ${active ? 'is-active' : ''} ${gift ? 'is-value' : ''}"><label class="mdb-offer-head"><input type="radio" data-tier name="${esc(this.id)}-tier" value="${count}" ${active ? 'checked' : ''} ${this.busy ? 'disabled' : ''} aria-controls="${esc(this.id)}-picks"><span class="mdb-offer-name"><span class="mdb-offer-title">${esc(title)}${gift ? '<span class="mdb-free-tag">🎁 + FREE gifts</span>' : ''}${gift && this.config.expressFree && count >= 5 ? '<span class="mdb-free-tag">🚚 + FREE Express Shipping</span>' : ''}${badge ? `<span class="mdb-badge">${esc(badge)}</span>` : ''}</span>${benefit ? `<span class="mdb-offer-benefit">${esc(benefit)}</span>` : ''}</span><span class="mdb-prices"><span class="mdb-total">${esc(this.money(amount.total))}</span>${count >= 3 && amount.compare > amount.total ? `<del aria-label="${esc(this.text('compare'))}">${esc(this.money(amount.compare))}</del>` : ''}</span>${gift ? this.giftBlock(count, amount, active, shipping) : ''}</label></div>`;
      }).join('');
      const picks = this.querySelector('[data-picks]');
      picks.id = this.id + '-picks';
      picks.hidden = this.count === 1;
      picks.classList.toggle('is-compact', this.count >= 3);
      const label = this.config.optionNames?.length === 1 ? this.config.optionNames[0] : this.text('style');
      if (this.count > 1 && !this.warmed) {
        this.warmed = true;
        this.variants.forEach(v => { if (v.image) { const img = new Image(); img.decoding = 'async'; img.src = v.image; } });
      }
      const activeOffer = this.querySelector('.mdb-offer.is-active');
      if (activeOffer && this.count > 1) activeOffer.append(picks);
      picks.innerHTML = this.count === 1 ? '' : `<div class="mdb-pick-heading"><span>${esc(label)}</span><button type="button" class="mdb-match" data-match ${this.busy ? 'disabled' : ''}>${esc(this.text('match_all'))}</button></div>${this.selected().map((v,index) => this.row(v,index)).join('')}`;
      this.querySelector('[data-shipping]').hidden = !(this.config.country === 'US' && this.config.currency === 'USD' && this.tierCounts().some(count => count > 1 && this.totals(count).total >= 5000));
      const unavailable = this.selected().some(v => !v.available);
      const add = this.querySelector('[data-add]');
      add.disabled = this.busy || unavailable || !!this.pending;
      add.setAttribute('aria-busy', String(this.busy));
      add.textContent = this.busy ? this.text('adding') : unavailable ? this.text('choose_available') : `${(this.count === 1 ? this.text('add_single') : this.text('add_items').replace('{count}',this.count))} · ${this.money(this.totals().total)}`;
      this.querySelector('.mdb-offers').disabled = this.busy;
      const wrapper = this.form?.closest('.product-form-wrapper');
      const nativeVariant = Number(this.form?.querySelector('[name="id"]')?.value);
      const showCheckout = this.count === 1 && !unavailable && !this.busy && !this.pending && nativeVariant === this.picks[0];
      wrapper?.classList.toggle('mdb-native-hidden', !showCheckout);
      wrapper?.classList.toggle('mdb-native-single', showCheckout);
      const note = this.querySelector('.mdb-note');
      note.textContent = this.count >= 3 && this.config.eligible ? this.config.gifts.note : this.text('note');
      if (wrapper && !this.checkoutNote) {
        this.checkoutNote = note.cloneNode(true);
        wrapper.append(this.checkoutNote);
      }
      const quiet = this.config.eligible && this.count < 3;
      note.hidden = showCheckout || quiet;
      if (this.checkoutNote) this.checkoutNote.hidden = !showCheckout || quiet;
      this.info?.querySelector('variant-picker')?.classList.toggle('mdb-native-hidden', this.count > 1);
      this.updateSticky();
    }
    setupLive() {
      const price = this.info?.querySelector('.product__price');
      const top = this.config.gifts.value?.[7];
      if (!this.config.eligible || !price || this.info.querySelector('.mdb-live')) return;
      price.insertAdjacentHTML('afterend', `<a class="mdb-live" href="#${this.escape(this.id)}">🎁 <b>Black Friday FREE gifts:</b> Fate Coin · Dice Bag · Mini Pendant · 35mm D20${this.config.expressFree ? ' · Collector’s Showcase' : ''} <span aria-hidden="true">›</span></a>`);
    }
    setupSticky() {
      const bar = document.createElement('div');
      bar.className = 'mdb-sticky';
      bar.hidden = true;
      bar.innerHTML = '<div class="mdb-sticky-info"><span class="mdb-sticky-title"></span><span class="mdb-sticky-price"></span></div><button type="button" class="mdb-sticky-add"></button>';
      document.body.append(bar);
      this.sticky = bar;
      this.listen(bar.querySelector('button'),'click', () => {
        const target = this.ctaTarget();
        if (target && !target.disabled) target.click();
        else this.scrollIntoView({behavior:'smooth',block:'start'});
      });
      let queued = false;
      const queue = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; this.updateSticky(); }); };
      this.listen(window,'scroll',queue,{passive:true});
      this.listen(window,'resize',queue);
    }
    ctaTarget() {
      return [this.querySelector('[data-add]'), this.form?.querySelector('button[type="submit"]')].find(button => button && button.offsetParent !== null);
    }
    updateSticky() {
      const bar = this.sticky;
      if (!bar || !this.config) return;
      const target = this.ctaTarget();
      const rect = target?.getBoundingClientRect();
      const show = !!rect && rect.bottom < 0;
      const amount = this.totals();
      const gift = this.config.eligible && this.count >= 3;
      bar.querySelector('.mdb-sticky-title').textContent = (this.count === 1 ? this.text('one') : this.config.gifts.items.replace('{count}',this.count)) + (gift ? ' + FREE gifts' : '');
      bar.querySelector('.mdb-sticky-price').innerHTML = `<b>${this.escape(this.money(amount.total))}</b>${this.count >= 3 && amount.compare > amount.total ? ` <s>${this.escape(this.money(amount.compare))}</s>` : ''}`;
      const add = bar.querySelector('button');
      add.textContent = this.busy ? this.text('adding') : this.text('add');
      add.disabled = this.busy;
      bar.hidden = !show;
      document.body.classList.toggle('mdb-has-sticky', show);
    }
    giftBlock(count, amount, active, shipping) {
      // The gifts themselves are the message: one photo per item with a FREE tag and its name.
      const esc = s => this.escape(s);
      const items = MastersdiceBundle.giftItems.filter(item => item.min <= count);
      const isNew = item => item.min === count && count > 3;
      const tiles = items.map((item,i) => {
        const price = this.config.gifts.itemPrice?.[item.icon];
        const inner = `${isNew(item) ? '<span class="mdb-gift-new">NEW</span>' : ''}<span class="mdb-gift-tile-img">${this.giftImage(item, active ? 168 : 128)}</span><span class="mdb-gift-tile-name">${esc(item.short)}</span><span class="mdb-gift-tile-price">${price > 0 ? `<s>${esc(this.money(price).replace(/\.00$/, ''))}</s> ` : ''}<b>FREE</b></span>`;
        return active
          ? `<button type="button" class="mdb-gift-tile${isNew(item) ? ' is-new' : ''}" data-gift-view="${count}" data-gift-index="${i}" aria-label="${esc('FREE ' + item.name + ': view photo')}">${inner}</button>`
          : `<span class="mdb-gift-tile${isNew(item) ? ' is-new' : ''}">${inner}</span>`;
      }).join('');
      return `<span class="mdb-gift${active ? ' is-open' : ''}"><span class="mdb-gift-tiles${items.length > 4 ? ' is-many' : ''}" style="--mdb-tiles:${items.length}">${tiles}</span></span>`;
    }
    tierCounts() { return this.config?.expressFree ? [...MastersdiceBundle.counts, 10] : MastersdiceBundle.counts; }
    giftImage(item, size) {
      const img = this.config.gifts.itemImg?.[item.icon];
      return img ? `<img src="${this.escape(img.s)}" alt="" width="${size}" height="${size}" loading="lazy" decoding="async">` : MastersdiceBundle.icons[item.icon];
    }
    openGift(count, index) {
      const esc = s => this.escape(s);
      const items = MastersdiceBundle.giftItems.filter(item => item.min <= count && this.config.gifts.itemImg?.[item.icon]);
      if (!items.length) return;
      const value = this.config.gifts.value?.[count] || 0;
      index = Math.min(index, items.length - 1);
      this.closeGift();
      const box = document.createElement('div');
      box.className = 'mdb-viewer';
      box.setAttribute('role','dialog');
      box.setAttribute('aria-modal','true');
      box.setAttribute('aria-label','Free gift photos');
      box.innerHTML = `<div class="mdb-viewer-top"><span class="mdb-viewer-count">${index + 1} / ${items.length}</span><button type="button" class="mdb-viewer-close" aria-label="Close">×</button></div><div class="mdb-viewer-track">${items.map(item => `<div class="mdb-viewer-slide"><img src="${esc(this.config.gifts.itemImg[item.icon].l)}" alt="${esc(item.name)}" decoding="async"></div>`).join('')}</div><div class="mdb-viewer-cap"><b>FREE with ${count}+ items${value ? ` · worth ${esc(this.money(value))}` : ''}</b><span data-viewer-name>${esc(items[index].name)}</span></div>`;
      document.body.append(box);
      document.documentElement.classList.add('mdb-viewer-open');
      const track = box.querySelector('.mdb-viewer-track');
      const counter = box.querySelector('.mdb-viewer-count');
      const name = box.querySelector('[data-viewer-name]');
      track.scrollLeft = track.clientWidth * index;
      track.addEventListener('scroll', () => {
        const i = Math.min(items.length - 1, Math.round(track.scrollLeft / track.clientWidth));
        counter.textContent = `${i + 1} / ${items.length}`;
        name.textContent = items[i].name;
      }, {passive:true});
      box.addEventListener('click', e => { if (e.target === box || e.target.closest('.mdb-viewer-close') || e.target.classList.contains('mdb-viewer-slide')) this.closeGift(); });
      this.giftKey = e => { if (e.key === 'Escape') this.closeGift(); };
      document.addEventListener('keydown', this.giftKey);
      this.viewer = box;
      box.querySelector('.mdb-viewer-close').focus({preventScroll:true});
    }
    closeGift() {
      if (!this.viewer) return;
      this.viewer.remove();
      this.viewer = null;
      document.documentElement.classList.remove('mdb-viewer-open');
      document.removeEventListener('keydown', this.giftKey);
    }
    row(v,index) {
      const esc = s => this.escape(s);
      const open = this.openIndex === index;
      const label = this.text('choose').replace('{number}',index + 1);
      return `<div class="mdb-pick ${open ? 'is-open' : ''}"><button type="button" class="mdb-choice mdb-trigger" data-open="${index}" ${this.busy ? 'disabled' : ''} aria-label="${esc(label + ': ' + v.title)}" aria-expanded="${open}" aria-controls="${esc(this.id)}-panel-${index}"><span class="mdb-item-number">${esc(this.text('item').replace('{number}',index + 1))}</span><span class="mdb-hero">${this.image(v,800,true)}</span><span class="mdb-choice-text"><span class="mdb-choice-name">${esc(v.title)}</span><span class="mdb-change">${esc(this.text('change_style'))} <span aria-hidden="true">${open ? '−' : '+'}</span></span></span></button>${open ? this.panel(index) : `<div id="${esc(this.id)}-panel-${index}" hidden></div>`}</div>`;
    }
    panel(index = this.openIndex) {
      const esc = s => this.escape(s);
      const v = this.selected()[index];
      const label = this.text('choose').replace('{number}',index + 1);
      return `<div class="mdb-panel" id="${esc(this.id)}-panel-${index}"><div class="mdb-panel-heading"><span>${esc(label)}</span><button type="button" class="mdb-close" data-close>${esc(this.text('close'))}</button></div><div class="mdb-grid">${this.variants.map(option => `<button type="button" class="mdb-option" data-variant="${option.id}" aria-label="${esc(option.title)}${option.available ? '' : ' · ' + esc(this.text('sold_out'))}" aria-pressed="${option.id === v.id}" ${option.available && !this.busy ? '' : 'disabled'}>${this.image(option,240)}<small>${esc(option.title)}${option.available ? '' : ' · ' + esc(this.text('sold_out'))}</small>${option.id === v.id ? '<span class="mdb-check" aria-hidden="true">✓</span>' : ''}</button>`).join('')}</div></div>`;
    }
    closePicker(focus = true) {
      const index = this.openIndex;
      if (index === null) return;
      const top = this.querySelector(`.mdb-trigger[data-open="${index}"]`)?.getBoundingClientRect().top;
      this.openIndex = null;
      this.render();
      const trigger = this.querySelector(`.mdb-trigger[data-open="${index}"]`);
      if (focus) {
        trigger?.focus({preventScroll:true});
        if (top !== undefined && trigger) window.scrollBy({top:trigger.getBoundingClientRect().top - top,behavior:'instant'});
      }
    }
    click(event) {
      const button = event.target.closest('button');
      if (!button || !this.contains(button) || button.disabled || this.busy) return;
      if (button.hasAttribute('data-gift-view')) {
        event.preventDefault();
        this.openGift(Number(button.dataset.giftView), Number(button.dataset.giftIndex));
      } else if (button.hasAttribute('data-open')) {
        const index = Number(button.dataset.open);
        if (this.openIndex === index) this.closePicker();
        else { this.openIndex = index; this.render(); this.querySelector('.mdb-panel:not([hidden]) .mdb-option[aria-pressed=true]')?.focus({preventScroll:true}); }
      } else if (button.hasAttribute('data-match')) {
        this.picks = this.picks.map((id,index) => index < this.count ? this.picks[0] : id);
        this.openIndex = null;
        this.clearError();
        this.render();
        this.querySelector('[data-match]')?.focus({preventScroll:true});
      } else if (button.hasAttribute('data-close')) this.closePicker();
      else if (button.hasAttribute('data-variant')) {
        const index = this.openIndex;
        if (index === null) return;
        this.picks[index] = Number(button.dataset.variant);
        this.closePicker();
        this.clearError();
        if (index === 0) this.syncNative();
      } else if (button.hasAttribute('data-add')) this.add();
    }
    syncNative() {
      const variant = this.selected(1)[0];
      const picker = this.info?.querySelector('variant-picker');
      if (!picker) return;
      const groups = [...picker.querySelectorAll('select, fieldset')];
      if (groups.length !== variant.options.length) return;
      let changedInput = null;
      groups.forEach((group,index) => {
        const value = variant.options[index];
        if (group.tagName === 'SELECT') {
          if (group.value !== value) { group.value = value; changedInput = group; }
          [...group.options].forEach(option => option.toggleAttribute('selected',option.value === value));
        } else {
          const input = [...group.querySelectorAll('input[type="radio"]')].find(input => input.value === value);
          if (input && !input.checked) { input.checked = true; changedInput = input; }
        }
      });
      if (changedInput) changedInput.dispatchEvent(new Event('change',{bubbles:true}));
    }
    clearError() { this.querySelector('[data-error]').hidden = true; this.querySelector('[data-status]').textContent = ''; this.querySelector('[data-cart-link]').hidden = true; }
    error(message, cart = false) { const error = this.querySelector('[data-error]'); error.textContent = message; error.hidden = false; this.querySelector('[data-cart-link]').hidden = !cart; }
    listen(target, type, handler, capture = false) {
      target.addEventListener(type,handler,capture);
      this.listeners.push({target,type,handler,capture});
    }
    removeListeners() {
      for (const listener of this.listeners || []) listener.target.removeEventListener(listener.type,listener.handler,listener.capture);
      this.listeners = [];
    }
    async requestJSON(path, options, timeout) {
      const controller = typeof AbortController === 'function' ? new AbortController() : null;
      const requestOptions = {...options};
      if (controller) requestOptions.signal = controller.signal;
      let timer;
      try {
        return await Promise.race([
          fetch(this.config.root + path,requestOptions).then(async response => ({response,data:response.ok || options.method === 'POST' ? await response.json() : null})),
          new Promise((_,reject) => {
            timer = setTimeout(() => {
              if (controller) controller.abort();
              reject(new Error(this.text('error')));
            },timeout);
          })
        ]);
      } finally { clearTimeout(timer); }
    }
    async getJSON(path) {
      const {response,data} = await this.requestJSON(path,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}},15000);
      if (!response.ok) throw new Error(this.text('error'));
      return data;
    }
    async updateCart(cart,added) {
      cart.sections = added?.sections;
      if (typeof theme !== 'undefined' && theme.pubsub) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate,{source:'product-form',productVariantId:this.picks[0],cart});
      if (added) document.dispatchEvent(new CustomEvent('ajaxProduct:added',{detail:{product:added}}));
      const drawer = document.querySelector('cart-drawer');
      if (drawer && added?.sections && Object.values(added.sections).every(Boolean)) drawer.show(this.querySelector('[data-add]'));
      else if (drawer) document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{open:true}}));
      else window.location.assign(this.config.root + 'cart');
    }
    quantities(cart) {
      const counts = {};
      cart.items.forEach(item => { counts[item.variant_id] = (counts[item.variant_id] || 0) + item.quantity; });
      return counts;
    }
    landed(cart,pending) {
      const after = this.quantities(cart);
      return pending.items.every(item => (after[item.id] || 0) - (pending.before[item.id] || 0) === item.quantity);
    }
    async add() {
      if (this.busy || this.pending || MastersdiceBundle.adding || this.selected().some(v => !v.available)) return;
      this.clearError();
      this.busy = true;
      MastersdiceBundle.adding = true;
      this.openIndex = null;
      this.render();
      let submitted = false;
      try {
        const fresh = await this.getJSON(`products/${encodeURIComponent(this.config.handle)}.js`);
        let changed = false;
        this.variants.forEach(v => {
          const current = fresh.variants.find(n => n.id === v.id);
          if (this.picks.slice(0,this.count).includes(v.id) && (!current || current.price !== v.price || current.available !== v.available)) changed = true;
          if (current) { v.price = current.price; v.available = current.available; v.compare_at_price = current.compare_at_price; }
          else v.available = false;
        });
        if (changed || this.selected().some(v => !v.available)) throw new Error(this.text('changed'));
        const items = [];
        for (const v of this.selected()) {
          const existing = items.find(item => item.id === v.id);
          if (existing) existing.quantity++;
          else items.push({id:v.id,quantity:1});
        }
        const before = this.quantities(await this.getJSON('cart.js'));
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections',{bubbles:true,detail:{sections}}));
        this.pending = {before,items};
        submitted = true;
        const {response,data:added} = await this.requestJSON('cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items,sections:[...new Set(sections)].slice(0,5),sections_url:window.location.pathname})},25000);
        if (!response.ok || added.status) {
          const error = new Error(added.description || this.text('error'));
          if (response.status >= 400 && response.status < 500) { this.pending = null; submitted = false; }
          throw error;
        }
        const cart = await this.getJSON('cart.js');
        if (!this.landed(cart,this.pending)) throw new Error(this.text('unknown'));
        this.pending = null;
        const actual = items.reduce((sum,item) => sum + item.quantity * (cart.items.find(line => line.variant_id === item.id && !Object.keys(line.properties || {}).length) || cart.items.find(line => line.variant_id === item.id)).final_price,0);
        if (actual !== this.totals().total) this.error(this.text('mismatch'),true);
        this.querySelector('[data-status]').textContent = this.text('added').replace('{count}',this.count).replace('{total}',this.money(cart.total_price));
        this.querySelector('[data-cart-link]').hidden = false;
        await this.updateCart(cart,added);
      } catch (error) {
        if (submitted && this.pending) {
          try {
            const cart = await this.getJSON('cart.js');
            if (this.landed(cart,this.pending)) {
              this.pending = null;
              this.querySelector('[data-status]').textContent = this.text('added').replace('{count}',this.count).replace('{total}',this.money(cart.total_price));
              await this.updateCart(cart,null);
            } else this.error(this.text('unknown'),true);
          } catch (_) { this.error(this.text('unknown'),true); }
        } else this.error(error.message || this.text('error'));
      } finally {
        this.busy = false;
        MastersdiceBundle.adding = false;
        if (this.queuedNativeVariant) { this.picks[0] = this.queuedNativeVariant; this.queuedNativeVariant = null; }
        this.render();
      }
    }
  }
  MastersdiceBundle.counts = [1,2,3,5,7];
  MastersdiceBundle.giftItems = [
    {min:3,icon:'coin',name:'Fate Coin',short:'Fate Coin'},
    {min:3,icon:'pouch',name:'Leather Dice Pouch',short:'Dice Bag'},
    {min:5,icon:'pendant',name:'Mini Dice Pendant',short:'Pendant'},
    {min:7,icon:'d20',name:'35mm Liquid Core D20',short:'35mm D20'},
    {min:10,icon:'stand',name:'Acrylic Collector’s Showcase (holds 10 Relic cubes)',short:'Showcase'}
  ];
  MastersdiceBundle.icons = {
    stand:'<svg viewBox="0 0 100 100"><rect width="100" height="100" fill="#f6ecd9"/><text x="50" y="13" text-anchor="middle" font-family="Georgia,serif" font-size="9" font-weight="700" fill="#5a3a1a">COLLECTOR’S</text><text x="50" y="23" text-anchor="middle" font-family="Georgia,serif" font-size="9" font-weight="700" fill="#5a3a1a">SHOWCASE</text><text x="50" y="32" text-anchor="middle" font-family="Georgia,serif" font-size="6" fill="#7a5a32">Holds 10 Relic cubes</text><path d="M14 80 L86 80 L80 88 L20 88 Z" fill="#e6f2f8" fill-opacity=".85" stroke="#8fb4c9" stroke-width="1"/><path d="M18 62 L82 62 L82 80 L18 80 Z" fill="#e6f2f8" fill-opacity=".85" stroke="#8fb4c9" stroke-width="1"/><path d="M22 44 L78 44 L78 62 L22 62 Z" fill="#e6f2f8" fill-opacity=".85" stroke="#8fb4c9" stroke-width="1"/><g fill="#b8893a" stroke="#4a3514" stroke-width=".6"><rect x="25" y="49" width="9" height="9" rx="1.2"/><rect x="36" y="49" width="9" height="9" rx="1.2"/><rect x="47" y="49" width="9" height="9" rx="1.2"/><rect x="58" y="49" width="9" height="9" rx="1.2"/><rect x="69" y="49" width="7" height="9" rx="1.2" opacity="0"/><rect x="21" y="67" width="9" height="9" rx="1.2"/><rect x="32" y="67" width="9" height="9" rx="1.2"/><rect x="43" y="67" width="9" height="9" rx="1.2"/><rect x="54" y="67" width="9" height="9" rx="1.2"/><rect x="65" y="67" width="9" height="9" rx="1.2"/></g><g fill="#b8893a" stroke="#4a3514" stroke-width=".6"><rect x="68" y="49" width="9" height="9" rx="1.2"/></g><g fill="#fff" opacity=".7"><rect x="26" y="50" width="3" height="1.5"/><rect x="37" y="50" width="3" height="1.5"/><rect x="48" y="50" width="3" height="1.5"/><rect x="59" y="50" width="3" height="1.5"/><rect x="69" y="50" width="3" height="1.5"/><rect x="22" y="68" width="3" height="1.5"/><rect x="33" y="68" width="3" height="1.5"/><rect x="44" y="68" width="3" height="1.5"/><rect x="55" y="68" width="3" height="1.5"/><rect x="66" y="68" width="3" height="1.5"/></g><path d="M24 45 L30 45 M20 63 L26 63" stroke="#fff" stroke-width="1.2" stroke-linecap="round"/></svg>',
    coin:'<svg viewBox="0 0 48 48"><circle cx="24" cy="24" r="19" fill="#e9c46a" stroke="#9a681f" stroke-width="2.5"/><circle cx="24" cy="24" r="13" fill="none" stroke="#9a681f" stroke-width="1.5" stroke-dasharray="2 2"/><path d="M24 15l2.6 5.6 6 .6-4.5 4 1.3 6-5.4-3.1-5.4 3.1 1.3-6-4.5-4 6-.6z" fill="#9a681f"/></svg>',
    pouch:'<svg viewBox="0 0 48 48"><path d="M15 17c-5 6-7 12-6 18 1 6 7 9 15 9s14-3 15-9c1-6-1-12-6-18z" fill="#8b5a2b" stroke="#5d3b0c" stroke-width="2"/><path d="M14 17h20" stroke="#e9c46a" stroke-width="3" stroke-linecap="round"/><path d="M17 17l-3-9M31 17l3-9M20 17l-1-7M28 17l1-7" stroke="#5d3b0c" stroke-width="2" stroke-linecap="round"/><path d="M34 17c4 1 6 4 6 6" stroke="#e9c46a" stroke-width="2" fill="none" stroke-linecap="round"/></svg>',
    pendant:'<svg viewBox="0 0 48 48"><path d="M10 4c3 10 8 14 14 14s11-4 14-14" fill="none" stroke="#9a9a9a" stroke-width="2" stroke-dasharray="3 2"/><circle cx="24" cy="20" r="2.5" fill="none" stroke="#9a681f" stroke-width="2"/><path d="M24 23l11 7v11l-11 6-11-6V30z" fill="#b48ad8" stroke="#5b3a85" stroke-width="2"/><path d="M24 23v8l11-1M24 31l-11-1M24 31l-6 13M24 31l6 13" stroke="#5b3a85" stroke-width="1.3" fill="none"/></svg>',
    d20:'<svg viewBox="0 0 48 48"><path d="M24 3l19 11v20L24 45 5 34V14z" fill="#3b82c4" stroke="#1e4f7a" stroke-width="2"/><path d="M24 13l11 18H13z" fill="#7fb8ea" stroke="#1e4f7a" stroke-width="1.5"/><path d="M24 3v10M43 14l-8 17M5 14l8 17M13 31l-8 3M35 31l8 3M13 31l11 14 11-14" stroke="#1e4f7a" stroke-width="1.5" fill="none"/><text x="24" y="28" font-size="8" font-weight="700" text-anchor="middle" fill="#0f2f4d" font-family="Arial">20</text></svg>'
  };
  customElements.define('mastersdice-bundle',MastersdiceBundle);
}
  } catch(e) { console.error(e); }
})();

})();
